exports = module.exports = require("../../../../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".successful-booking-with-no-payment{display:flex;justify-content:center}", ""]);

// exports
